import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "community",
  "use": "community-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"community\"><path d=\"M10 5.25H6v1.5h4v-1.5zm-1.5 3H6v1.5h2.5v-1.5zm6.48-1.09c.01.11.02.22.02.34 0 .94-.19 1.84-.53 2.66.01.11.03.22.03.34V15H10c-1.33 0-2.5-.59-3.32-1.5H8c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6v6h2.83c1.04 1.79 2.96 3 5.17 3h6v-6c0-1.23-.38-2.38-1.02-3.34zM3.5 12V7.5C3.5 5.01 5.51 3 8 3c1.42 0 2.67.67 3.49 1.7.08.1.17.2.25.3.48.72.76 1.57.76 2.5 0 2.49-2.01 4.5-4.5 4.5H3.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol